import {
  createStyles,
  Group,
  Title,
  Text,
  Card,
  SimpleGrid,
  Container,
  rem,
  Button,
  Box,
  SegmentedControl,
  Badge,
  TextInput,
} from '@mantine/core';
import { IconCalendar, IconWorld, IconCheck, IconBolt } from '@tabler/icons-react';
import { FAQ } from './FAQ';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Define translations based on language prefixes
const translations = {
  '/nl': {
    title: 'Kies het perfecte plan voor uw woning.',
    subscription: 'Prijsplannen',
    description:
      'Of u nu één appartement bezit of een vastgoedportefeuille,wij hebben een \noplossing voor u.',
    oneAccommodation: 'Eén accommodatie',
    oneAccomadationDescribe: 'Eén accommodatie, één adres',
    resiCollective: 'Resi Collective',
    resiCollectiveDescribe: 'Meerdere accommodaties, één adres',
    resiPortfolio: 'Resi Portfolio',
    resiPortfolioDescribe: 'Meerdere accommodaties, meerdere adressen',
    noOfUnits: 'Aantal eenheden',
    website: 'Website',
    websiteSub: 'Professionele website voor uw vermelding',
    calendar: 'Kalender',
    calendarSub: 'Beschikbaarheidsbeheer',
    combination: 'Combinatie',
    websitePlusCalendar: 'Website + Kalender',
    featureFullWebsite: 'Volledige websitefuncties',
    featureAdvancedSync: 'Geavanceerde kalendersynchronisatie',
    chooseCombination: 'Kies combinatie',
    getStartedHeading: 'Aan de slag met ResiRent',
    featuresHeading: 'FUNCTIES',
    getStartedCta: 'Aan de slag',
    getStartedSub: 'Kies het opstartniveau dat past bij uw vertrouwen en planning.',
    bottomFeature1Title: 'Flexibel opschalen',
    bottomFeature1Text: 'Upgrade van Single naar Collective naarmate uw bedrijf groeit.',
    bottomFeature2Title: 'Geen verborgen kosten',
    bottomFeature2Text: 'Transparante prijzen voor websites en kalendertools.',
    bottomFeature3Title: 'Veilige betalingen',
    bottomFeature3Text: 'Alle transacties worden veilig verwerkt.',
    setupPlans: [
      {
        title: 'DIY – zelf bouwen',
        price: 'Gratis',
        subprice: '(gratis)',
        blurb: 'Voor hosts die graag de controle houden en in hun eigen tempo starten.',
        features: [
          'Bouw uw eigen website met ResiWeb',
          'Volledige toegang tot alle kernfuncties',
          '1 uur gratis vragen & hulp',
          'Leer vanaf dag één hoe uw website werkt',
        ],
        note: '"Ideaal als u ResiRent eerst wil verkennen en stap voor stap vertrouwen wil opbouwen."',
      },
      {
        title: 'Begeleide setup – samen bouwen',
        price: '€499',
        subprice: '(eenmalig)',
        blurb: 'Voor hosts die ondersteuning en duidelijkheid willen bij de correcte setup.',
        features: [
          'We bouwen uw website samen',
          '4 uur persoonlijke begeleiding',
          'Structuur, inhoud en instellingen correct',
          'Tips gebaseerd op echte short-stay ervaring',
        ],
        note: '"Een populaire keuze voor hosts die fouten willen vermijden en tijd willen besparen."',
      },
      {
        title: 'Wij bouwen uw website – startklaar',
        price: '€999',
        subprice: '(eenmalig)',
        blurb: 'Voor hosts die professioneel willen starten, zonder afhankelijk te worden.',
        features: [
          'Wij bouwen uw volledige website',
          'Structuur, content en basisconfig inbegrepen',
          '1 uur overdracht & onderhoudstraining',
          'Geen black box: u blijft in controle',
        ],
        note: '"Helder, eerlijk en gericht op zelfstandigheid op lange termijn."',
      },
    ],
  },
  '/de': {
    title: 'Wählen Sie den perfekten Plan für Ihr Grundstück',
    subscription: 'Preispläne',
    description:
      'Ob Sie eine einzelne Wohnung oder ein Immobilienportfolio besitzen,wir haben die \npassende Lösung für Sie.',
    oneAccommodation: 'Eine Unterkunft',
    oneAccomadationDescribe: 'Eine Unterkunft, eine Adresse',
    resiCollective: 'Resi Collective',
    resiCollectiveDescribe: 'Mehrere Unterkünfte, eine Adresse',
    resiPortfolio: 'Resi Portfolio',
    resiPortfolioDescribe: 'Mehrere Unterkünfte, mehrere Adressen',
    noOfUnits: 'Anzahl der Einheiten',
    website: 'Webseite',
    websiteSub: 'Professionelle Inserats-Website',
    calendar: 'Kalender',
    calendarSub: 'Verwaltung der Verfügbarkeit',
    combination: 'Kombination',
    websitePlusCalendar: 'Webseite + Kalender',
    featureFullWebsite: 'Alle Webseitenfunktionen',
    featureAdvancedSync: 'Erweiterte Kalendersynchronisierung',
    chooseCombination: 'Kombination wählen',
    getStartedHeading: 'So starten Sie mit ResiRent',
    featuresHeading: 'FUNKTIONEN',
    getStartedCta: 'Loslegen',
    getStartedSub: 'Wählen Sie das Setup-Niveau, das zu Ihrem Vertrauen und Zeitplan passt.',
    bottomFeature1Title: 'Flexible Skalierung',
    bottomFeature1Text: 'Upgrade von Single zu Collective, wenn Ihr Geschäft wächst.',
    bottomFeature2Title: 'Keine versteckten Gebühren',
    bottomFeature2Text: 'Transparente Preise für Webseiten und Kalendertools.',
    bottomFeature3Title: 'Sichere Zahlungen',
    bottomFeature3Text: 'Alle Transaktionen werden sicher verarbeitet.',
    setupPlans: [
      {
        title: 'DIY – selbst bauen',
        price: 'Kostenlos',
        subprice: '(kostenlos)',
        blurb: 'Für Gastgeber, die die Kontrolle behalten und in ihrem eigenen Tempo starten möchten.',
        features: [
          'Bauen Sie Ihre eigene Website mit ResiWeb',
          'Voller Zugriff auf alle Kernfunktionen',
          '1 Stunde kostenlose Fragen & Hilfe',
          'Lernen Sie von Anfang an, wie Ihre Website funktioniert',
        ],
        note: '"Ideal, wenn Sie ResiRent zuerst erkunden und Schritt für Schritt Vertrauen aufbauen möchten."',
      },
      {
        title: 'Geführte Einrichtung – gemeinsam bauen',
        price: '€499',
        subprice: '(einmalig)',
        blurb: 'Für Gastgeber, die Unterstützung und Klarheit bei der Einrichtung wünschen.',
        features: [
          'Wir bauen Ihre Website gemeinsam',
          '4 Stunden persönliche Begleitung',
          'Struktur, Inhalte und Einstellungen korrekt',
          'Tipps aus echter Kurzzeitvermietungserfahrung',
        ],
        note: '"Beliebt bei Gastgebern, die Fehler vermeiden und Zeit sparen möchten."',
      },
      {
        title: 'Wir bauen Ihre Website – startklar',
        price: '€999',
        subprice: '(einmalig)',
        blurb: 'Für Gastgeber, die professionell starten möchten, ohne abhängig zu werden.',
        features: [
          'Wir bauen Ihre komplette Website',
          'Struktur, Inhalt und Basiskonfiguration inklusive',
          '1 Stunde Übergabe & Wartungsschulung',
          'Keine Black Box: Sie behalten die Kontrolle',
        ],
        note: '"Klar, ehrlich und auf langfristige Unabhängigkeit ausgerichtet."',
      },
    ],
  },
  '/': {
    title: 'Choose the perfect plan for your property',
    subscription: 'Pricing Plans',
    description:
      'Whether you have a single apartment or a portfolio of properties,we have a \nsolution for you.',
    oneAccommodation: 'One Accommodation',
    oneAccomadationDescribe: 'One accommodation, one address',
    resiCollective: 'Resi Collective',
    resiCollectiveDescribe: 'Multiple accommodations, one address',
    resiPortfolio: 'Resi Portfolio',
    resiPortfolioDescribe: 'Multiple accommodations, multiple addresses',
    noOfUnits: 'No of Units',
    website: 'Website',
    websiteSub: 'Professional listing website',
    calendar: 'Calendar',
    calendarSub: 'Availability Management Tool',
    combination: 'Combination',
    websitePlusCalendar: 'Website + Calendar',
    featureFullWebsite: 'Full Website Features',
    featureAdvancedSync: 'Advanced Calendar Sync',
    chooseCombination: 'Choose Combination',
    getStartedHeading: 'How to get started with ResiRent',
    featuresHeading: 'FEATURES',
    getStartedCta: 'Get started',
    getStartedSub: 'Choose the setup level that fits your confidence and schedule.',
    bottomFeature1Title: 'Flexible Scaling',
    bottomFeature1Text: 'Upgrade from Single to Collective as your business grows.',
    bottomFeature2Title: 'No Hidden Fees',
    bottomFeature2Text: 'Transparent pricing for websites and calendar tools.',
    bottomFeature3Title: 'Secure Payments',
    bottomFeature3Text: 'All transactions are processed securely.',
    setupPlans: null, // default to SETUP_PLANS
  },
};

// Combination pricing for Website + Calendar (provided by user)
const COMBO_PRICING = {
  monthly: {
    one: 42,
    collective: { 2: 57, 3: 70, 4: 83 },
    portfolio: { 2: 69, 3: 87, 4: 104 },
  },
  annual: {
    one: 549,
    collective: { 2: 799, 3: 999, 4: 1199 },
    portfolio: { 2: 999, 3: 1299, 4: 1599 },
  },
};

// Setup plans below pricing
const SETUP_PLANS = [
   {
    title: 'DIY – build it yourself',
    price: 'Free',
    subprice: '(free)',
    blurb: 'For hosts who like to stay in control and get started at their own pace.',
    features: [
      'Build your own website with ResiWeb',
      'Full access to all core features',
      '1 hour of free questions & help',
      'Learn how your website works from day one',
    ],
    note: '"Ideal if you want to explore ResiRent first and build confidence step by step."',
  },
  {
    title: 'Guided Setup – build together',
    price: '€499',
    subprice: '(one-time)',
    blurb: 'For hosts who want support and clarity while setting everything up correctly.',
    features: [
      'We build your website together',
      '4 hours of personal guidance',
      'Structure, content and settings done right',
      'Tips based on real short-term rental experience',
    ],
    note: '"A popular choice for hosts who want to avoid mistakes and save time."',
  },
  {
    title: 'We build your website – ready to go',
    price: '€999',
    subprice: '(one-time)',
    blurb: 'For hosts who want a professional start, without becoming dependent.',
    features: [
      'We build your complete website for you',
      'Structure, content and basic setup included',
      '1 hour handover & maintenance training',
      'No black box: you stay in full control',
    ],
    note: '"Clear, honest, and focused on long-term independence."',
  },
];

const useStyles = createStyles((theme) => ({
  description: {
    [theme.fn.smallerThan('sm')]: {
      fontSize: rem(16),
      maxWidth: '100%',
      textAlign: 'center',
      display: 'block',
    },
    maxWidth: rem(700),
    margin: 'auto',
    fontWeight: 400,
    color: theme.colors.gray[6],
    whiteSpace: 'pre-wrap',
  },
  title: {
    [theme.fn.smallerThan('sm')]: {
      fontSize: rem(28),
      maxWidth: '100%',
    },
    maxWidth: '100%',
    fontSize: rem(48),
    fontWeight: 800,
  },
  card: {
    border: `1px solid #E9ECEF`,
    borderRadius: rem(12),
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
    minHeight: rem(600),
  },
  featureRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #E9ECEF',
    borderRadius: rem(8),
    padding: `${rem(18)} ${rem(18)}`,
    marginTop: rem(12),
    background: '#fff',
  },
  comboCard: {
    border: '2px solid #094D57',
    background: '#E6FFFA',
    borderRadius: rem(12),
    padding: `${rem(20)} ${rem(20)}`,
    marginTop: rem(16),
  },
  setupCard: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  setupHeading: {
    color: '#094D57',
    fontWeight: 700,
  },
  setupPrice: {
    marginBottom: rem(20),
  },
  featuresItem: {
    lineHeight: 1.7,
    flex: 1,
    minWidth: 0
  },
  noteBox: {
    backgroundColor: '#F2F7F6',
    border: '1px solid #E0E8E5',
    borderRadius: rem(8),
    padding: `${rem(10)} ${rem(12)}`,
    color: '#6B7B78',
    fontStyle: 'italic',
    textAlign: 'center',
    marginTop: rem(76),
  },
  // Units segmented control (light green background with white active button)
  unitsRoot: {
    backgroundColor: '#EFFFF6',
    padding: 4,
    borderRadius: rem(12),
  },
  unitsIndicator: {
    backgroundColor: theme.white,
    borderRadius: rem(10),
    boxShadow: '0 1px 3px rgba(16,24,40,0.15)',
    border: '1px solid #E5F2EC',
  },
  unitsControl: {
    backgroundColor: 'transparent',
    border: '0 !important',
    boxShadow: 'none !important',
    '&[data-active]': {
      backgroundColor: 'transparent',
      border: '0 !important',
      boxShadow: 'none !important',
    },
    '&:not(:first-of-type)': {
      borderLeft: '0 !important',
    },
    '& + *': {
      borderLeft: '0 !important',
    },
    '::before': {
      display: 'none',
    },
  },
  comboButton: {
  width: '100%',
  backgroundColor: '#094D57',
  '&:hover': { backgroundColor: '#094D57' },
  color: theme.white,
  borderRadius: rem(6),
  height: rem(48),
  boxShadow: '0 2px 6px rgba(16,24,40,0.15)',
},
  unitsLabel: {
    color: '#0B3B40',
    fontWeight: 600,
    padding: `${rem(10)} ${rem(10)}`,
  },
  segLabel: {
    color: '#065b6681',
    fontWeight: 500,
    padding: `${rem(10)} ${rem(14)}`,
    '&[data-active]': {
      color: '#FFFFFF',
    },
  },
  segLabelActive: {
    color: theme.white,
  },
  segControl: {
    backgroundColor: 'transparent',
    transition: 'background-color 150ms ease',
    '&[data-active]': {
      backgroundColor: 'transparent',
      borderColor: '#0B5B66',
    },
  },
  segIndicator: {
    backgroundColor: '#0B5B66',
    border: '1px solid #0B5B66',
    borderRadius: rem(8),
  },
  segRoot: {
    backgroundColor: theme.white,
    border: '1px solid #E9ECEF',
    padding: 4,
    borderRadius: rem(8),
    boxShadow: '0 2px 6px rgba(16,24,40,0.06)'
  },
}));

// Temporary pricing (replace later). Annual = 12  monthly.
const PRICING = {
  monthly: {
    one: { website: 32, calendar: 10 },
    collective: {
      2: { website: 42, calendar: 15 },
      3: { website: 50, calendar: 20 },
      4: { website: 58, calendar: 25 },
    },
    portfolio: {
      2: { website: 54, calendar: 15 },
      3: { website: 67, calendar: 20 },
      4: { website: 79, calendar: 25 },
    },
  },
  annual: {
    one: { website: 349, calendar: 249 },
    collective: {
      2: { website: 499, calendar: 349 },
      3: { website: 599, calendar: 449 },
      4: { website: 699, calendar: 549 },
    },
    portfolio: {
      2: { website: 649, calendar: 349 },
      3: { website: 799, calendar: 449 },
      4: { website: 949, calendar: 549 },
    },
  },
};

export function Prices() {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const languagePrefix = window.location.pathname.startsWith('/nl')
    ? '/nl'
    : window.location.pathname.startsWith('/de')
    ? '/de'
    : '/';

  const [billing, setBilling] = useState('monthly');
  const [collectiveUnits, setCollectiveUnits] = useState(2);
  const [portfolioUnits, setPortfolioUnits] = useState(2);

  const fmt = (v) => (billing === 'monthly' ? `€${v}/mo` : `€${v}/yr`);
  const tdict = translations[languagePrefix] || translations['/'];
  const LOCALIZED_SETUP = tdict.setupPlans || SETUP_PLANS;

  return (
    <Container size="xl" py={100}>
      <Group position="center">
        <Title order={4} weight={600} align="center" color="resirentPink">
          {tdict.subscription}
        </Title>
      </Group>

      <Title order={1} className={classes.title} ta="center" mt="sm">
        {tdict.title}
      </Title>

      <Text className={classes.description} ta="center" my="lg">
        {tdict.description}
      </Text>

      <Group position="center" mt="50px" mb="70px">
        <SegmentedControl
          value={billing}
          onChange={setBilling}
          color="teal"
          radius="xs"
          classNames={{ label: classes.segLabel, control: classes.segControl, root: classes.segRoot, indicator: classes.segIndicator }}
          data={[
            { label: 'Monthly billing', value: 'monthly' },
            { label: 'Annual billing', value: 'annual' },
          ]}
        />
      </Group>

      <SimpleGrid cols={3} spacing="xl" mt={30} breakpoints={[{ maxWidth: 'md', cols: 1 }]}>
        {/* One Accommodation */}
        <Card withBorder padding="xl" className={classes.card}>
          <Group spacing="xs" mb="md">
            <Badge radius="lg" variant="light" color="teal" leftSection={<IconBolt size={18} color="#0B5B66" />} />
            <Text fw={700} c="#0B5B66" fz="lg">{tdict.oneAccommodation}</Text>
            <Text fw={600} fz="md">{tdict.oneAccomadationDescribe}</Text>
          </Group>

          <Text c="dimmed" fz="md" mb="xs">{tdict.noOfUnits}</Text>
          <SegmentedControl
            value={'1'}
            onChange={() => {}}
            
            fullWidth
            radius="md"
            size="md"
            classNames={{ root: classes.unitsRoot, indicator: classes.unitsIndicator, control: classes.unitsControl, label: classes.unitsLabel }}
            data={[{ label: '1', value: '1' }]}
          />

          <Box className={classes.featureRow} mt="lg">
            <Group spacing="sm">
              <IconWorld size={20} />
              <div>
                <Text fw={600} fz="md">{tdict.website}</Text>
                <Text fz="sm" c="dimmed">{tdict.websiteSub}</Text>
              </div>
            </Group>
            <Text fw={700} fz="lg">{fmt(PRICING[billing].one.website)}</Text>
          </Box>

          <Box className={classes.featureRow}>
            <Group spacing="sm">
              <IconCalendar size={20} />
              <div>
                <Text fw={600} fz="md">{tdict.calendar}</Text>
                <Text fz="sm" c="dimmed">{tdict.calendarSub}</Text>
              </div>
            </Group>
            <Text fw={700} fz="lg">{fmt(PRICING[billing].one.calendar)}</Text>
          </Box>

          <Box className={classes.comboCard}>
            <Group position="apart" mb={6}>
              <Group spacing="sm">
                <IconCalendar size={18} />
                <Text fw={700} fz="lg">{tdict.combination}</Text>
              </Group>
              <Text fw={800} fz="xl">{fmt(COMBO_PRICING[billing].one)}</Text>
            </Group>
            <Text fz="md" fw={500} style={{ lineHeight: 1.6 }}>{tdict.websitePlusCalendar}</Text>
            <Box mt={8}>
              <Group spacing={8}>
                <IconCheck size={16} color="#0CA678" />
                <Text fz="sm" style={{ lineHeight: 1.6 }}>{tdict.featureFullWebsite}</Text>
              </Group>
              <Group spacing={8} mt={6}>
                <IconCheck size={16} color="#0CA678" />
                <Text fz="sm" style={{ lineHeight: 1.6 }}>{tdict.featureAdvancedSync}</Text>
              </Group>
            </Box>
            <Button mt={20} radius="md" fullWidth className={classes.comboButton} onClick={() => navigate('/register')}> 
              {tdict.chooseCombination}
            </Button>
          </Box>
        </Card>

        {/* Resi Collective */}
        <Card withBorder padding="xl" className={classes.card}>
          <Group spacing="xs" mb="md">
            <Badge radius="xl" variant="light" color="teal" leftSection={<IconWorld size={14} color="#0B5B66" />} />
            <Text fw={700} c="#0B5B66" fz="lg">{tdict.resiCollective}</Text>
            <Text fw={600} fz="md">{tdict.resiCollectiveDescribe}</Text>
          </Group>

          <Text c="dimmed" fz="md" mb="xs">{tdict.noOfUnits}</Text>
          <SegmentedControl
            value={String(collectiveUnits)}
            onChange={(v) => setCollectiveUnits(Number(v))}
            fullWidth
            radius="md"
            size="md"
            classNames={{ root: classes.unitsRoot, indicator: classes.unitsIndicator, control: classes.unitsControl, label: classes.unitsLabel }}
            data={[
              { label: '2', value: '2' },
              { label: '3', value: '3' },
              { label: '4', value: '4' },
            ]}
          />

          <Box className={classes.featureRow} mt="lg">
            <Group spacing="sm">
              <IconWorld size={20} />
              <div>
                <Text fw={600} fz="md">{tdict.website}</Text>
                <Text fz="sm" c="dimmed">{tdict.websiteSub}</Text>
              </div>
            </Group>
            <Text fw={700} fz="lg">{fmt(PRICING[billing].collective[collectiveUnits].website)}</Text>
          </Box>

          <Box className={classes.featureRow}>
            <Group spacing="sm">
              <IconCalendar size={20} />
              <div>
                <Text fw={600} fz="md">{tdict.calendar}</Text>
                <Text fz="sm" c="dimmed">{tdict.calendarSub}</Text>
              </div>
            </Group>
            <Text fw={700} fz="lg">{fmt(PRICING[billing].collective[collectiveUnits].calendar)}</Text>
          </Box>

          <Box className={classes.comboCard}>
            <Group position="apart" mb={6}>
              <Group spacing="sm">
                <IconCalendar size={18} />
                <Text fw={700} fz="lg">{tdict.combination}</Text>
              </Group>
              <Text fw={800} fz="xl">{fmt(COMBO_PRICING[billing].collective[collectiveUnits])}</Text>
            </Group>
            <Text fz="md" fw={500} style={{ lineHeight: 1.6 }}>{tdict.websitePlusCalendar}</Text>
            <Box mt={8}>
              <Group spacing={8}>
                <IconCheck size={16} color="#0CA678" />
                <Text fz="sm" style={{ lineHeight: 1.6 }}>{tdict.featureFullWebsite}</Text>
              </Group>
              <Group spacing={8} mt={6}>
                <IconCheck size={16} color="#0CA678" />
                <Text fz="sm" style={{ lineHeight: 1.6 }}>{tdict.featureAdvancedSync}</Text>
              </Group>
            </Box>
            <Button mt={20} radius="md" fullWidth className={classes.comboButton} onClick={() => navigate('/register')}>
              {tdict.chooseCombination}
            </Button>
          </Box>
        </Card>

        {/* Resi Portfolio */}
        <Card withBorder padding="xl" className={classes.card}>
          <Group spacing="xs" mb="md">
            <Badge radius="xl" variant="light" color="teal" leftSection={<IconWorld size={14} color="#0B5B66" />} />
            <Text fw={700} c="#0B5B66" fz="lg">{tdict.resiPortfolio}</Text>
            <Text fw={600} fz="md">{tdict.resiPortfolioDescribe}</Text>
          </Group>

          <Text c="dimmed" fz="md" mb="xs">{tdict.noOfUnits}</Text>
          <SegmentedControl
            value={String(portfolioUnits)}
            onChange={(v) => setPortfolioUnits(Number(v))}
            fullWidth
            radius="md"
            size="md"
            classNames={{ root: classes.unitsRoot, indicator: classes.unitsIndicator, control: classes.unitsControl, label: classes.unitsLabel }}
            data={[
              { label: '2', value: '2' },
              { label: '3', value: '3' },
              { label: '4', value: '4' },
            ]}
          />

          <Box className={classes.featureRow} mt="lg">
            <Group spacing="sm">
              <IconWorld size={20} />
              <div>
                <Text fw={600} fz="md">{tdict.website}</Text>
                <Text fz="sm" c="dimmed">{tdict.websiteSub}</Text>
              </div>
            </Group>
            <Text fw={700} fz="lg">{fmt(PRICING[billing].portfolio[portfolioUnits].website)}</Text>
          </Box>

          <Box className={classes.featureRow}>
            <Group spacing="sm">
              <IconCalendar size={20} />
              <div>
                <Text fw={600} fz="md">{tdict.calendar}</Text>
                <Text fz="sm" c="dimmed">{tdict.calendarSub}</Text>
              </div>
            </Group>
            <Text fw={700} fz="lg">{fmt(PRICING[billing].portfolio[portfolioUnits].calendar)}</Text>
          </Box>

          <Box className={classes.comboCard}>
            <Group position="apart" mb={6}>
              <Group spacing="sm">
                <IconCalendar size={18} />
                <Text fw={700} fz="lg">{tdict.combination}</Text>
              </Group>
              <Text fw={800} fz="xl">{fmt(COMBO_PRICING[billing].portfolio[portfolioUnits])}</Text>
            </Group>
            <Text fz="md" fw={500} style={{ lineHeight: 1.6 }}>{tdict.websitePlusCalendar}</Text>
            <Box mt={8}>
              <Group spacing={8}>
                <IconCheck size={16} color="#0CA678" />
                <Text fz="sm" style={{ lineHeight: 1.6 }}>{tdict.featureFullWebsite}</Text>
              </Group>
              <Group spacing={8} mt={6}>
                <IconCheck size={16} color="#0CA678" />
                <Text fz="sm" style={{ lineHeight: 1.6 }}>{tdict.featureAdvancedSync}</Text>
              </Group>
            </Box>
            <Button mt={20} radius="md" fullWidth className={classes.comboButton} onClick={() => navigate('/register')}>
              {tdict.chooseCombination}
            </Button>
          </Box>
        </Card>
      </SimpleGrid>

      <Title order={1} ta="center" mt={120}>{tdict.getStartedHeading}</Title>
      <Text className={classes.description} ta="center" mt="sm" mb={50}>
        {tdict.getStartedSub}
      </Text>

      <SimpleGrid cols={3} spacing="xl" mt={10} breakpoints={[{ maxWidth: 'md', cols: 1 }]}>
        {LOCALIZED_SETUP.map((plan) => (
          <Card key={plan.title} withBorder padding="xl" className={`${classes.card} ${classes.setupCard}`}>
            <Text fw={700} className={classes.setupHeading}>{plan.title}</Text>
            <Title order={2} mt="sm">{plan.price}</Title>
            {<Text c="dimmed" fz="sm" mb="sm" className={classes.setupPrice}>{plan.subprice}</Text>}
            <Text c="dimmed" mt="md">{plan.blurb}</Text>

            <Box mt="md" style={{ borderTop: '1px solid #E9ECEF', paddingTop: 12 }}>
              <Text fw={700} fz="sm" mb={8}>{tdict.featuresHeading}</Text>
              {plan.features.map((feat, idx) => (
                <Group spacing={8} key={idx} mt={6}>
                  <IconCheck size={16} color="#0CA678" />
                  <Text fz="sm" className={classes.featuresItem}>{feat}</Text>
                </Group>
              ))}
            </Box>

            {plan.note && (
              <Box className={classes.noteBox}>
                {plan.note}
              </Box>
            )}

            <Box style={{ flexGrow: 1 }} />
            <Button mt={10} radius="md" fullWidth className={classes.comboButton} onClick={() => navigate('/register')}>
              {tdict.getStartedCta}
            </Button>
          </Card>
        ))}
      </SimpleGrid>

      {/* Feature strip: Flexible Scaling / No Hidden Fees / Secure Payments */}
      <SimpleGrid cols={3} spacing="xl" mt={160} mb={60} breakpoints={[{ maxWidth: 'md', cols: 1 }]}> 
        <Box ta="center">
          <Text fw={700} mt={8} mb={10} fz="xl">{tdict.bottomFeature1Title}</Text>
          <Text c="dimmed" fz="sm">{tdict.bottomFeature1Text}</Text>
        </Box>
        <Box ta="center">
          <Text fw={700} mt={8} mb={10} fz="xl">{tdict.bottomFeature2Title}</Text>
          <Text c="dimmed" fz="sm">{tdict.bottomFeature2Text}</Text>
        </Box>
        <Box ta="center">
          <Text fw={700} mt={8} mb={10} fz="xl">{tdict.bottomFeature3Title}</Text>
          <Text c="dimmed" fz="sm">{tdict.bottomFeature3Text}</Text>
        </Box>
      </SimpleGrid>

      <Box bg="#FFFFFF" mt={0}>
        <FAQ />
      </Box>
    </Container>
  );
}
